// extracted by mini-css-extract-plugin
module.exports = {"rowHeightNum":"50","rowHeight":"50px","sectionContainerVPadding":"20px","sectionContainerHPadding":"25px"};